export default __webpack_public_path__ + "static/media/news1.321d7d08.png";